import { render, staticRenderFns } from "./pillar.vue?vue&type=template&id=8b3e87f0&scoped=true&"
import script from "./pillar.vue?vue&type=script&lang=js&"
export * from "./pillar.vue?vue&type=script&lang=js&"
import style0 from "./pillar.vue?vue&type=style&index=0&id=8b3e87f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3e87f0",
  null
  
)

export default component.exports